import { InfoOutlined } from "@mui/icons-material";
import { Box, Button, Grid, styled } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const StyledBox = styled(Box)(({ theme }) => ({
  borderRadius: "3px",
  marginTop: "15px",
  padding: "20px",
  backgroundColor: theme.palette.error.light,
  display: "inline-flex",
  width: "100%",
}));

export default function NegativeEarningsBanner() {
  return (
    <StyledBox>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingRight: "15px" }}>
        <InfoOutlined color="error" />
      </div>
      <Grid container alignItems="center">
        <Grid item xs={12} md={7}>
          <div style={{ fontWeight: "600", fontSize: "16px", marginBottom: "5px" }}>
            Your account balance is negative. Please clear your dues to continue placing orders.
          </div>
          <div style={{ fontSize: "14px" }}>Asset Retrieval creation is disabled until payment is added.</div>
        </Grid>
        <Grid item xs={12} md={5} display="flex" alignItems="center" justifyContent="flex-end">
          <Button size="small" variant="contained" component={RouterLink} to="/company-settings/payment-info">
            Add a credit card to resume
          </Button>
        </Grid>
      </Grid>
    </StyledBox>
  );
}
